import React, { useEffect, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { useGLTF } from '@react-three/drei'

// Antes se animaba con framer-motion-3d (descontinuado). Se reproducen sus mismas curvas: "easeInOut" es
// cubic-bezier(0.42, 0, 0.58, 1) y los keyframes de 3 valores se reparten en dos mitades, cada una con easeInOut.
function cubicBezier(x1, y1, x2, y2) {
  const curve = (s, a, b) => ((1 - 3 * b + 3 * a) * s + (3 * b - 6 * a)) * s * s + 3 * a * s
  return (t) => {
    if (t <= 0) return 0
    if (t >= 1) return 1
    let low = 0, high = 1, s = t
    for (let i = 0; i < 20; i++) {
      s = (low + high) / 2
      if (curve(s, x1, x2) < t) low = s
      else high = s
    }
    return curve(s, y1, y2)
  }
}
const easeInOut = cubicBezier(0.42, 0, 0.58, 1)
const lerp = (from, to, progress) => from + (to - from) * progress
// Avance (0 a 1) de un tramo que empieza a los `delay` segundos y dura `duration`.
const progress = (t, delay, duration) => easeInOut(Math.min(Math.max((t - delay) / duration, 0), 1))
const keyframes = (t, delay, duration, [a, b, c]) => {
  const half = duration / 2
  return t < delay + half ? lerp(a, b, progress(t, delay, half)) : lerp(b, c, progress(t, delay + half, half))
}

const AnforaAnimate = ({tiempo,error,onStart}) => {

  const { nodes, materials } = useGLTF('/anfora.glb')
  const anfora = useRef(null)
  const tapa = useRef(null)
  const cupon = useRef(null)
  const startedAt = useRef(null)
  // El modelo ya cargó: desde aquí corre la animación (el padre cuenta el tiempo desde este momento)
  useEffect(() => {
    startedAt.current = performance.now()
    onStart?.()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const girosAnfora = Math.trunc(tiempo/2)

  useFrame(() => {
    if (startedAt.current === null) return
    const t = (performance.now() - startedAt.current) / 1000
    // La ánfora gira, se destapa y el cupón sale hacia la cámara (si hubo error, el cupón solo gira).
    anfora.current.rotation.x = lerp(-Math.PI / 3, ((girosAnfora)*6-1)*Math.PI / 3, progress(t, 1, tiempo - 6))
    tapa.current.position.y = lerp(0, 65, progress(t, tiempo - 5, 2))
    const salida = (values) => keyframes(t, tiempo - 3, 3, error ? [values[0], values[0], values[0]] : values)
    cupon.current.scale.setScalar(salida([1, 1, 2]))
    cupon.current.position.set(salida([0, 0, -300]), salida([0, 0, -200]), salida([0, 100, 150]))
    cupon.current.rotation.set(keyframes(t, tiempo - 3, 3, [0, 0, Math.PI / 2]), keyframes(t, tiempo - 3, 3, [0, 0, Math.PI / 3]), 0)
  })

  return (
    <group dispose={null}>
      <group ref={anfora} rotation={[-Math.PI / 3, 0, Math.PI / 2]}>
        <mesh ref={tapa} geometry={nodes.tapa.geometry} material={materials['Brass Glossy']} />
        <mesh geometry={nodes.text.geometry} material={materials['Gold Glossy 27']} position={[-97.96, -86.27, 7.79]} scale={1.24} />
        <mesh geometry={nodes.vertex.geometry} material={materials['Gold Glossy 7']} position={[0.01, 0, -91.65]} />
        <mesh geometry={nodes.body.geometry} material={materials['Gold Glossy 2']} position={[0, -0.5, -89.87]} />
        <group ref={cupon}>
          <mesh geometry={nodes.data.geometry} material={materials['Refresh 1']} position={[11.66, -0.22, 12.81]} rotation={[0, 0, Math.PI]} />
          <mesh geometry={nodes.coupon.geometry} material={materials.Columbia} position={[12.09, -17.5, 28]} rotation={[-Math.PI / 2, 0, Math.PI]} />
        </group>
      </group>
    </group>
  )
}

export default AnforaAnimate
